import {Button} from 'antd';
import {Input} from 'antd/es';
import Form from 'antd/es/form';
import {useForm} from 'antd/es/form/Form';
import React, {useEffect, useState, FC} from 'react';

import {ActionBar} from 'components/@common/widgets/action-bar';
import {AIS_ROUTES} from 'components/ais/ais.constants';
import {ModalOpenerComponent} from 'components/modal-opener-component';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {showMessage} from 'shared/utils/notifications';
import {showRequestErrorMessage} from 'shared/utils/show-message-from-response';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

import {fetchForecastComments, sendForecastComments} from '../../api/thunks';
import {FORECAST_COMMENTS_ACTION_PANEL_TITLE} from '../../model/constants';
import {selectForecastCommentsFilters} from '../../model/slice';
import {TForecastCommentsActionPanelForm} from '../../model/types';

export const ForecastCommentsActionPanel: FC = () => {
    const dispatch = useAppDispatch();

    const {requestId, status} = useAppSelector(selectForecastCommentsFilters) ?? {};

    const [form] = useForm<TForecastCommentsActionPanelForm>();

    const [isOpen, setOpen] = useState(false);

    const {hasUserRoleFunction} = useUserRoleFunctions({sections: [AIS_ROUTES.FORECAST_COMMENTS]});
    const isNewRequest = status === false;
    const isSendResponseButtonHidden = !(isNewRequest && hasUserRoleFunction(EUserRoleFunction.CREATE));

    useEffect(() => {
        form.resetFields();
    }, [requestId]);

    const handleFinish = async () => {
        if (!requestId) {
            console.error('Ошибка: requestId не найден');
            return;
        }

        try {
            const response = await dispatch(sendForecastComments({requestId})).unwrap();

            showMessage({message: response});
            dispatch(fetchForecastComments({requestId}));
            setOpen(false);
        } catch (error) {
            showRequestErrorMessage(error);
        }
    };

    return (
        <ActionBar
            side="left"
            transparent
        >
            <ModalOpenerComponent
                isOpen={isOpen}
                setIsOpen={setOpen}
                component={
                    <Button
                        type="primary"
                        disabled={!requestId}
                        hidden={isSendResponseButtonHidden}
                    >
                        Сформировать ответ
                    </Button>
                }
                modalProps={{title: 'Вызвать сервис', centered: true, width: '780px'}}
                handleSave={() => {
                    form.submit();
                }}
                controlLabels={{save: 'Отправить', cancel: 'Закрыть'}}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                >
                    <Form.Item
                        name="name"
                        label="Наименование сервиса"
                        initialValue={FORECAST_COMMENTS_ACTION_PANEL_TITLE}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        name="requestId"
                        label="Номер запроса"
                        initialValue={requestId}
                    >
                        <Input disabled />
                    </Form.Item>
                </Form>
            </ModalOpenerComponent>
        </ActionBar>
    );
};

ForecastCommentsActionPanel.displayName = 'ForecastCommentsActionPanel';
